export var VolumeProfileWindow;
(function (VolumeProfileWindow) {
    VolumeProfileWindow["currentSession"] = "currentSession";
    VolumeProfileWindow["priorSession"] = "priorSession";
})(VolumeProfileWindow || (VolumeProfileWindow = {}));
export var VolumeProfileStrength;
(function (VolumeProfileStrength) {
    VolumeProfileStrength["veryWeak"] = "veryWeak";
    VolumeProfileStrength["weak"] = "weak";
    VolumeProfileStrength["neutral"] = "neutral";
    VolumeProfileStrength["strong"] = "strong";
    VolumeProfileStrength["veryStrong"] = "veryStrong";
})(VolumeProfileStrength || (VolumeProfileStrength = {}));
export var VolumeProfileValueAreaRelationship;
(function (VolumeProfileValueAreaRelationship) {
    VolumeProfileValueAreaRelationship["belowValue"] = "belowValue";
    VolumeProfileValueAreaRelationship["insideValue"] = "insideValue";
    VolumeProfileValueAreaRelationship["aboveValue"] = "aboveValue";
})(VolumeProfileValueAreaRelationship || (VolumeProfileValueAreaRelationship = {}));
export var VolumeProfileLevelRelationship;
(function (VolumeProfileLevelRelationship) {
    VolumeProfileLevelRelationship["below"] = "below";
    VolumeProfileLevelRelationship["at"] = "at";
    VolumeProfileLevelRelationship["above"] = "above";
})(VolumeProfileLevelRelationship || (VolumeProfileLevelRelationship = {}));
export var VolumeProfileReferenceKind;
(function (VolumeProfileReferenceKind) {
    VolumeProfileReferenceKind["poc"] = "poc";
    VolumeProfileReferenceKind["valueAreaHigh"] = "valueAreaHigh";
    VolumeProfileReferenceKind["valueAreaLow"] = "valueAreaLow";
    VolumeProfileReferenceKind["nearestHvnAbove"] = "nearestHvnAbove";
    VolumeProfileReferenceKind["nearestHvnBelow"] = "nearestHvnBelow";
    VolumeProfileReferenceKind["nearestLvnAbove"] = "nearestLvnAbove";
    VolumeProfileReferenceKind["nearestLvnBelow"] = "nearestLvnBelow";
    VolumeProfileReferenceKind["lowVolumePocket"] = "lowVolumePocket";
})(VolumeProfileReferenceKind || (VolumeProfileReferenceKind = {}));
export var VolumeProfileEventType;
(function (VolumeProfileEventType) {
    VolumeProfileEventType["enteredValueArea"] = "enteredValueArea";
    VolumeProfileEventType["exitedValueArea"] = "exitedValueArea";
    VolumeProfileEventType["reclaimedPoc"] = "reclaimedPoc";
    VolumeProfileEventType["lostPoc"] = "lostPoc";
    VolumeProfileEventType["acceptedAboveVah"] = "acceptedAboveVah";
    VolumeProfileEventType["acceptedBelowVal"] = "acceptedBelowVal";
    VolumeProfileEventType["rejectedAtVah"] = "rejectedAtVah";
    VolumeProfileEventType["rejectedAtVal"] = "rejectedAtVal";
    VolumeProfileEventType["traversedNearestLvn"] = "traversedNearestLvn";
    VolumeProfileEventType["enteredLowVolumePocket"] = "enteredLowVolumePocket";
    VolumeProfileEventType["exitedLowVolumePocket"] = "exitedLowVolumePocket";
})(VolumeProfileEventType || (VolumeProfileEventType = {}));
//# sourceMappingURL=VolumeProfileAnalyzerTypes.js.map